<template>
	<div id="app" :style="cssProps" :class="appClasses">
		<component :is="layout.layout"></component>
	</div>
</template>

<style lang="sass">
@import "../styles/sass/import/node/import"
</style>

<script>

import { mapGetters, mapState } from 'vuex';

import AppLayout from '@/views/layouts/AppLayout';
import SalesLayout from '@/views/layouts/SalesLayout';
import BlankLayout from '@/views/layouts/BlankLayout';
import { DEFAULTS, getDefaults } from '@/utils/colors';
import getSubdomain from '@/utils/get-subdomain';

export default {

	metaInfo() {
		let titleSuffix = this.whiteLabelAccount.company || this.currentAccount.company || 'Gravity Fox';
		return {
			title: this.layout.title,
			titleTemplate: '%s | ' + titleSuffix,
			bodyAttrs: {
				class: this.layout.theme,
			},
		};
	},

	data() {
		return {
			colors: {},
		};
	},

	computed: {
		...mapState({
			layout: state => state.layout,
			platform: state => state.platform,
		}),

		...mapGetters(['whiteLabelAccount', 'currentAccount']),

		cssProps() {
			return {
				'--brand-color': this.colors.brand_color,
				'--good': this.colors.good,
				'--bad': this.colors.bad,
				'--neutral': this.colors.neutral,
			};
		},

		appClasses() {
			let classes = [
				this.layout.menuOpen ? 'nav-open' : null,
				this.layout.accountMenuOpen ? 'account-switch-open' : null,
			];
			return classes.filter(o => o).join(' ');
		},
	},

	mounted() {
		this.colors = this.getAccountColors();
		this.$root.$on('colors', (colors) => {
			console.log('setting colors');
			this.colors = {
				brand_color: colors.brand_color || DEFAULTS.BRAND,
				good: colors.good || DEFAULTS.GOOD,
				bad: colors.bad || DEFAULTS.BAD,
				neutral: colors.neutral || DEFAULTS.NEUTRAL,
			};
		});
		this.$root.$on('reset-colors', () => {
			this.colors = this.getAccountColors();
		});
		this.$root.$on('set-default-colors', () => {
			this.colors = getDefaults();
		});
		this.$root.$on('lookup-company', () => {
			this.lookupCompany();
		});
	},

	methods: {

		async lookupCompany() {
			const subdomain = getSubdomain();
			if (subdomain) {
				await this.$store.dispatch('loadWhiteLabelAccount', subdomain);
			} else {
				this.$root.$emit('reset-colors');
			}
		},



		getAccountColors() {
			return {
				brand_color: this.currentAccount.brand_color || DEFAULTS.BRAND,
				good: this.currentAccount.good || DEFAULTS.GOOD,
				bad: this.currentAccount.bad || DEFAULTS.BAD,
				neutral: this.currentAccount.neutral || DEFAULTS.NEUTRAL,
			};
		},

	},

	components: {
		AppLayout,
		SalesLayout,
		BlankLayout,
	},

};

</script>
